import request from '@/router/axios'

/**
 * 发送短信验证码
 * @author Shawn Fenng
 * @Date 2019-11-23
 * @param arguments
 */
export function sendValidateMessage(phonenumber, validateCode, __captchaVerification) {
  return request({
    url: "/api/business/portal/forget/validatemsg/" + phonenumber,
    method: "get",
    params: { validateCode, __captchaVerification }
  })
}

/**
 * 验证短信验证码
 * @author Shawn Fenng
 * @Date 2019-11-23
 * @param smsCode
 */
export function checkSmsCode(phonenumber, smsCode) {
  return request({
    url: "/api/business/portal/forget/checksmscode",
    method: "get",
    params: { phonenumber, smsCode }
  })
}

/**
 * 前台重置密码
 * @author Shawn Fenng
 * @Date 2019-11-25
 * @param arguments
 */
export function resetPassword(phonenumber, password) {
  return request({
    url: '/api/business/portal/forget/resetPassword',
    method: 'post',
    data: { phonenumber, password }
  })
}